<template>
  <div class="container--is-maxwidth container--padded faq">
    <div class="title" v-if="options.title" v-html="options.title"></div>
    <div class="faq_accordions__wrapper">
        <div class="accordion__list" v-for="(list, index) in faqData" :key="index">
            <button class="accordion" v-html="list.Question"/>
            <span class="faq-accordion-btn" :class="{'is-open': list.isDefault}"  @click="toggle(index,list.Question)"/>
            <div class="accordion-content" v-html="list.Answer"></div>
        </div>
    </div>
  </div>
</template>

<script>
import { AnalyticsHandler } from '@Foundation/analyticsHandler';
export default {
    name:'faq',
    props:{
        options: {
            type: Object,
            default() {
            return undefined;
            }
        },
        pageCategory:{ type: String, required: false, default: '' },
    },
    data() {
        return {
            faqData : []
        }
    },
    created() {
        const data = this.options;
        data.list.forEach(element => { 
            const list = {};
            list.Question = element.Question;
            list.Answer = element.Answer;
            list.isDefault = false;
            this.faqData.push(list);
        });
    },
    methods: {
        toggle(index,accordianTitle) {
            this.faqData[index].isDefault = !this.faqData[index].isDefault;
            let accTitle =accordianTitle.replace("(+)","plus").toLowerCase();
            AnalyticsHandler.pushDataLayer({
                'event': 'uaevent',
                'ecommerce':'undefined',
                'event_name': 'body_button_click',
                'eventCategory': this.pageCategory,
                'eventAction': 'select::faq',
                'eventLabel': accTitle+'::none',
                'module_name': 'faq',
                'cta_name': accTitle,
                'link_url': 'none'
            });
        }
    }

}
</script>
<style lang="scss" src="./faq.scss"></style>